<template>
  <li>
    <div>
      <slot />
    </div>
  </li>
</template>

<script>
  export default {
    name: 'content-list-item'
  }
</script>

<style lang="scss" scoped>
  li {
    width: 100%;

    & div {
      font-size: initial;
    }
  }
</style>